<template>
  <div class="summary">
    <!-- Headline -->
    <div class="summary-copy">
      <div class="wysiwyg">
        <h1><span>You're almost done</span>One Last Step</h1>
        <p>
          Congratulations on configuring your custom SKU! Below is a summary of
          the specifications you've selected. Please take a moment to save it
          for your records, add it to your clipboard, request a quote, or print
          it off.
        </p>
      </div>
    </div>

    <!-- Product Summary -->
    <div class="summary-sku full">
      <div class="sku_product">
        <div class="info">
          <img
            v-if="product.thumbnail && product.thumbnail.src"
            :src="product.thumbnail.src.url"
            :alt="`Image of ${product.title}`"
            :srcset="product.thumbnail.srcset"
            sizes="(max-width: 20.625em) 21vw, (max-width: 34em) 13vw, (max-width: 46.875em) 9vw, (max-width: 61.9375em) 8vw, (max-width: 68.75em) 7vw, 70px"
          />
          <div class="txt">
            <h4>{{ product.title }}</h4>
            <h6 v-if="showConfiguratorPricing">
              Estimated Total: {{ currencyFormatter(runningTotal) }}
              <div class="total-note">Tariff surcharges and associated fees are not included</div>
            </h6>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="actions">
          <!-- Quote Request, contains modal -->
          <quote-request
            @completed="$emit('completed')"
            :configurations="[{ product: product, selections: selections, id: product.id }]"
          >
            Get a Quote
          </quote-request>
        </div>
      </div>

      <div class="sku_details">
        <h5>Your Custom SKU</h5>
        <div class="actions">
          <a href="#" class="btn_edit">Edit</a>
          <!-- Share Sku Button, only appears on share-enabled devices -->
          <share-sku-button :sku-string="skuString"></share-sku-button>
          <!-- Copy Button, contains hidden form -->
          <copy-button :value="skuString">Copy Sku</copy-button>
          <!-- Save to Clipboard Button -->
          <button
            type="button"
            class="btn_save"
            :disabled="pendingSaveRequest"
            @click="$emit('save')"
          >
            {{ clipboardId ? "Update Clipboard" : "Save to Clipboard" }}
          </button>
          <!-- Print Button, contains window -->
          <print-button
            ref="print"
            :product="product"
            :selections="selections"
            :runningTotal="runningTotal"
            :showConfiguratorPricing="showConfiguratorPricing"
          >
            Print
          </print-button>
        </div>
        <!--- SKU component -->
        <sku
          :headline="false"
          :simplified="true"
          :product="product"
          :selections="selections"
        />
      </div>

      <div class="sku_desc">
        <div class="header">
          <h5>Schedule Description</h5>
          <copy-button
            :value="descriptionString"
            button-class="btn_copy"
            container-class=""
          >
            Copy
          </copy-button>
        </div>
        <ul class="options">
          <li v-for="(step, index) in product.steps" :key="step.title">
            <span class="num">
              <i>{{ calculateStepNumberFromArrayIndex(index) }}</i>
            </span>
            <span class="txt">
              <b>{{ step.title }}</b>
              <span class="summary-option" :set="(option = selectedOption(step))">
                <i>{{ option && option.label ? option.label : "No selection" }}</i>
                <em v-if="option && option.price && showConfiguratorPricing">
                  [{{ currencyFormatter(option.price) }}]
                </em>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import QuoteRequest from "../QuoteRequest";
import CopyButton from "../CopyButton";
import PrintButton from "./PrintButton";
import ShareSkuButton from "./ShareSkuButton";
import Sku from "../Sku";
import currencyFormatter from "../../../currency_formatter.js";

export default {
  components: {
    CopyButton,
    QuoteRequest,
    PrintButton,
    ShareSkuButton,
    Sku,
  },
  props: {
    product: {},
    selections: {},
    runningTotal: 0,
    pendingSaveRequest: {
      type: Boolean,
      default: false,
    },
    clipboardId: {},
    showConfiguratorPricing: false,
  },
  mounted() {
    if (location.hash === "#print") {
      this.$refs.print.open();
    }
  },
  data() {
    return {
      currencyFormatter,
    };
  },
  computed: {
    skuString() {
      let skuString = this.product.sku;

      this.product.steps.forEach((step) => {
        if (this.selections[step.id] && this.selections[step.id].external) {
          skuString = skuString.concat(`-${this.selections[step.id].external}`);
        } else {
          skuString = skuString.concat(`-???`);
        }
      });

      return skuString;
    },
    descriptionString() {
      let string = `${this.product.title}: ${this.product.family} - ${this.product.model} - ${this.product.type}`;

      this.product.steps.forEach((step) => {
        let selectedSku = this.selections[step.id];
        let value = ` - ${step.title}: No selection`;
        if (selectedSku) {
          step.options.forEach((option) => {
            if (selectedSku == option.sku) {
              value = ` - ${step.title}: ${option.label}`;
            }
          });
        }
        string = string.concat(value);
      });

      return string;
    },
  },
  methods: {
    calculateStepNumberFromArrayIndex(index) {
      return index + 1;
    },
    selectedOption(step) {
      return step.options.find(({ internal_id }) => this.selections[step.id] && internal_id === this.selections[step.id].internal);
    },
    openPrintView() {},
  },
};
</script>
